<button
  mat-menu-item
  (click)="editFolder()"
>
  <mat-icon>edit</mat-icon>
  <span>{{ T.G.EDIT | translate }}</span>
</button>

<button
  mat-menu-item
  (click)="deleteFolder()"
>
  <mat-icon>delete</mat-icon>
  <span>{{ T.G.DELETE | translate }}</span>
</button>
